import { createFileRoute } from "@tanstack/react-router";
import { BAA_MARKDOWN } from "@alm/domain/legal";
import { marketingHead } from "@/lib/marketing/seo";
import { breadcrumbs, webPageOf } from "@/lib/marketing/ppl-schema";
import { MarketingShell } from "@/components/marketing/site/marketing-shell";
import { LegalDocument } from "@/components/marketing/site/legal/legal-document";
import { LegalPrintButton } from "@/components/marketing/site/legal/legal-print-button";
import { siteLink } from "@/components/marketing/site/legal/legal-site-link";

export const Route = createFileRoute("/v2/baa")({
  component: BaaPage,
  head: () => {
    const seo = {
      title: "Business Associate Agreement | PEOPLE AI Workforce",
      description:
        "The PPL AI Business Associate Agreement under HIPAA: part of the Terms of Service, accepted with every order before any resident information is entered.",
      path: "/v2/baa",
      imageAlt: "PEOPLE AI Workforce",
    };
    return marketingHead({
      ...seo,
      schema: [webPageOf(seo), breadcrumbs({ name: "Business Associate Agreement", path: "/baa" })],
    });
  },
});

function BaaPage() {
  return (
    <MarketingShell>
      <article className="legal-document mx-auto max-w-3xl px-6 py-16 sm:py-24">
        <div className="mb-8 flex justify-end">
          <LegalPrintButton testId="button-print-baa" />
        </div>
        <LegalDocument markdown={BAA_MARKDOWN} link={siteLink} />
      </article>
    </MarketingShell>
  );
}
